import { Component, Input, OnDestroy, OnInit, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss']
})
export class LoaderComponent implements OnInit, OnDestroy, OnChanges {

  @Input() isLoading: boolean = false; // Accept input from parent component

  loadingMessages = [
    "Importing Your Data",
    "Hold on for a few seconds",
    "This will take a few more seconds"
  ];
  loadingMessage = this.loadingMessages[0];
  messageIndex = 0;
  interval: any;

  constructor() { }

  ngOnInit() {
    if (this.isLoading) {
      this.startLoading(); // Start loading based on the initial value
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['isLoading']) {
      if (this.isLoading) {
        this.startLoading(); // Start when isLoading is true
      } else {
        this.stopLoading();  // Stop when isLoading is false
      }
    }
  }

  startLoading() {
    this.interval = setInterval(() => {
      this.messageIndex = (this.messageIndex + 1) % this.loadingMessages.length;
      this.loadingMessage = this.loadingMessages[this.messageIndex];
    }, 2000); // Change message every 2 seconds
  }

  stopLoading() {
    clearInterval(this.interval);
  }

  ngOnDestroy() {
    clearInterval(this.interval);
  }
}
